const ACCOUNTING_REPORT_KEYS = new Set([
  'journal-report',
  'general-ledger',
  'trial-balance',
  'profit-loss',
  'balance-sheet',
  'cash-flow',
  'accounts-payable-aging',
  'expense-breakdown',
  'asset-register',
  'depreciation-schedule',
]);

const normalizeValue = value => String(value ?? '').trim();

const appendIfPresent = (params, key, value) => {
  const normalized = normalizeValue(value);
  if (normalized) {
    params.set(key, normalized);
  }
};

export const isValidReportCenterDateInput = value =>
  /^\d{4}-\d{2}-\d{2}$/.test(normalizeValue(value));

export const buildReportCenterPath = ({
  tab = 'business',
  report = '',
  posReport = '',
  accountingReport = '',
  outletId = '',
  dateFrom = '',
  dateTo = '',
} = {}) => {
  const normalizedTab = normalizeValue(tab) || 'business';
  const params = new URLSearchParams();

  params.set('tab', normalizedTab);

  if (normalizedTab === 'business') {
    appendIfPresent(params, 'report', report);
  }

  if (normalizedTab === 'pos') {
    appendIfPresent(params, 'pos_report', posReport);
  }

  if (normalizedTab === 'accounting') {
    const normalizedAccountingReport = normalizeValue(accountingReport);
    if (ACCOUNTING_REPORT_KEYS.has(normalizedAccountingReport)) {
      params.set('accounting_report', normalizedAccountingReport);
    }
  }

  appendIfPresent(params, 'outlet_id', outletId);

  if (isValidReportCenterDateInput(dateFrom)) {
    params.set('date_from', dateFrom);
  }

  if (isValidReportCenterDateInput(dateTo)) {
    params.set('date_to', dateTo);
  }

  return `/report-center?${params.toString()}`;
};

export const buildAccountingReportCenterPath = (accountingReport, options = {}) =>
  buildReportCenterPath({
    ...options,
    tab: 'accounting',
    accountingReport,
  });
